import React from 'react';

const Logo = ({ 
  size = 'default', 
  showText = true, 
  onClick,
  className = '',
  textColor = 'text-gray-900',
  hoverTextColor = 'hover:text-primary-600',
  customBgGradient = null
}) => {
  // Size configurations
  const sizeConfig = {
    small: {
      containerSize: 'w-6 h-6',
      iconSize: 'w-4 h-4',
      textSize: 'text-lg',
    },
    default: {
      containerSize: 'w-8 h-8',
      iconSize: 'w-5 h-5',
      textSize: 'text-xl',
    },
    large: {
      containerSize: 'w-10 h-10',
      iconSize: 'w-6 h-6',
      textSize: 'text-xl',
    },
    hero: {
      containerSize: 'w-20 h-20',
      iconSize: 'w-10 h-10',
      textSize: 'text-4xl md:text-5xl lg:text-6xl xl:text-7xl',
    }
  };

  const config = sizeConfig[size] || sizeConfig.default;
  const bgGradient = customBgGradient || 'bg-brand-primary';

  const logoContent = (
    <>
      <div className={`${config.containerSize} rounded-full flex items-center justify-center overflow-hidden`}>
        <img 
          src="/logo512.png" 
          alt="Your Therapist Logo" 
          className={`${config.containerSize} object-contain`}
        />
      </div>
      {showText && (
        <span className={`${config.textSize} font-bold ${textColor} ${hoverTextColor} transition-colors`}>
          Your Therapist
        </span>
      )}
    </>
  );

  if (onClick) {
    return (
      <div 
        className={`flex items-center gap-2 cursor-pointer ${className}`}
        onClick={onClick}
      >
        {logoContent}
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {logoContent}
    </div>
  );
};

export default Logo;
